const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const weighted = (items) => {
  const r = Math.random();
  let cum = 0;
  for (const [item, w] of items) { cum += w; if (r < cum) return item; }
  return items[items.length - 1][0];
};

// ─── Pool 1: Cities grouped by region ────────────────────────────────
const northeast = [
  'Newark NJ','Jersey City NJ','Hoboken NJ','Paterson NJ','Edison NJ','Trenton NJ',
  'Clifton NJ','Passaic NJ','Elizabeth NJ','Woodbridge NJ','Toms River NJ','Cherry Hill NJ',
  'Brooklyn NY','Queens NY','Manhattan NY','Bronx NY','Staten Island NY','Yonkers NY',
  'Buffalo NY','Rochester NY','Syracuse NY','Albany NY','White Plains NY',
  'Stamford CT','Hartford CT','New Haven CT','Bridgeport CT',
  'Boston MA','Worcester MA','Cambridge MA','Springfield MA',
  'Philadelphia PA','Pittsburgh PA','Allentown PA','Reading PA',
  'Providence RI','Portland ME','Burlington VT',
];
const southeast = [
  'Miami FL','Tampa FL','Orlando FL','Jacksonville FL','Fort Lauderdale FL','St. Petersburg FL',
  'Sarasota FL','Naples FL','Tallahassee FL','Gainesville FL',
  'Atlanta GA','Savannah GA','Augusta GA',
  'Charlotte NC','Raleigh NC','Durham NC','Greensboro NC','Wilmington NC',
  'Nashville TN','Memphis TN','Knoxville TN','Chattanooga TN',
  'Charleston SC','Columbia SC','Greenville SC',
  'Richmond VA','Virginia Beach VA','Arlington VA','Alexandria VA',
  'Baltimore MD','Annapolis MD',
  'New Orleans LA','Baton Rouge LA',
  'Birmingham AL','Huntsville AL',
];
const midwest = [
  'Chicago IL','Aurora IL','Naperville IL','Evanston IL','Schaumburg IL','Joliet IL',
  'Detroit MI','Grand Rapids MI','Ann Arbor MI','Lansing MI',
  'Columbus OH','Cleveland OH','Cincinnati OH','Dayton OH','Toledo OH',
  'Indianapolis IN','Fort Wayne IN','Bloomington IN',
  'Milwaukee WI','Madison WI','Green Bay WI',
  'Minneapolis MN','St. Paul MN','Rochester MN',
  'Kansas City MO','St. Louis MO','Springfield MO',
  'Omaha NE','Des Moines IA','Wichita KS',
];
const southwest = [
  'Dallas TX','Houston TX','Austin TX','San Antonio TX','Fort Worth TX','El Paso TX',
  'Plano TX','Irving TX','Frisco TX','McKinney TX','Arlington TX','Round Rock TX',
  'Phoenix AZ','Tucson AZ','Scottsdale AZ','Mesa AZ','Tempe AZ','Chandler AZ',
  'Denver CO','Colorado Springs CO','Boulder CO','Aurora CO','Fort Collins CO',
  'Las Vegas NV','Reno NV','Henderson NV',
  'Albuquerque NM','Santa Fe NM',
  'Oklahoma City OK','Tulsa OK',
  'Salt Lake City UT','Provo UT',
];
const west = [
  'Los Angeles CA','San Francisco CA','San Diego CA','San Jose CA','Sacramento CA',
  'Long Beach CA','Oakland CA','Irvine CA','Pasadena CA','Santa Monica CA',
  'Anaheim CA','Riverside CA','Bakersfield CA','Fresno CA','Santa Barbara CA',
  'Seattle WA','Tacoma WA','Bellevue WA','Spokane WA',
  'Portland OR','Eugene OR','Salem OR','Bend OR',
  'Honolulu HI','Anchorage AK','Boise ID',
];

const regions = [northeast, southeast, midwest, southwest, west];
const allCities = regions.flat();

function pickRoute() {
  const local = Math.random() < 0.6;
  if (local) {
    const region = pick(regions);
    const from = pick(region);
    let to = pick(region);
    while (to === from) to = pick(region);
    return { from, to };
  }
  const from = pick(allCities);
  let to = pick(allCities);
  while (to === from) to = pick(allCities);
  return { from, to };
}

// ─── Pool 2: First names (American standard) ────────────────────────
const names = [
  'James','John','Robert','Michael','David','William','Richard','Joseph','Thomas','Christopher',
  'Daniel','Matthew','Anthony','Mark','Steven','Andrew','Joshua','Kenneth','Kevin','Brian',
  'George','Timothy','Ronald','Jason','Jeffrey','Ryan','Jacob','Gary','Nicholas','Eric',
  'Jonathan','Stephen','Larry','Justin','Scott','Brandon','Benjamin','Samuel','Patrick','Frank',
  'Mary','Patricia','Jennifer','Linda','Barbara','Elizabeth','Susan','Jessica','Sarah','Karen',
  'Lisa','Nancy','Betty','Margaret','Sandra','Ashley','Dorothy','Kimberly','Emily','Donna',
  'Michelle','Carol','Amanda','Melissa','Deborah','Stephanie','Rebecca','Sharon','Laura','Cynthia',
  'Katherine','Christine','Samantha','Rachel','Catherine','Carolyn','Janet','Maria','Heather','Diane',
  'Carlos','Miguel','Jose','Luis','Diego','Sofia','Isabella','Alejandro','Gabriel','Marco',
];

// ─── Pool 3: Reviews ────────────────────────────────────────────────
const reviews = [
  'Careful with my furniture, great team',
  'On time, under budget!',
  'Best movers I\'ve ever hired',
  'Made our cross-state move stress-free',
  'Professional and fast, 10/10',
  'Super friendly crew, highly recommend',
  'Everything arrived in perfect condition',
  'They even helped reassemble my desk',
  'Showed up early and finished ahead of schedule',
  'Fair price, no hidden fees at all',
  'Would absolutely use them again',
  'Handled my piano with extra care',
  'The packing service saved us so much time',
  'Smooth move from start to finish',
  'Communicated every step of the way',
  'Really impressed with the whole process',
  'Five stars, no hesitation',
  'Made moving day actually enjoyable',
  'Quick, efficient, and very polite',
  'They treated our stuff like their own',
  'Incredible value for the price we paid',
  'Moved our entire office in one day',
  'Way better than our last moving company',
  'The team lead was super organized',
  'No damage, no stress, no complaints',
  'Honestly the easiest move we\'ve had',
  'They wrapped everything so carefully',
  'Helped us move on short notice, lifesavers',
  'Great experience, already told our neighbors',
  'Went above and beyond with the heavy items',
  'Loaded the truck in under two hours',
  'Very respectful of our home, wore shoe covers',
  'The quote was accurate, no surprises on moving day',
];

// ─── Pool 4: Company names ──────────────────────────────────────────
const companies = [
  'Swift Movers LLC','AllState Relocations','Eagle Van Lines','Metro Moving Co',
  'First Choice Movers','SafeHaul Transport','Summit Moving Group','Patriot Relocation',
  'Liberty Moving Co','Precision Movers','Atlas Home Movers','Golden State Moving',
  'Pinnacle Relocations','Horizon Movers','CrossCountry Express','Trusted Hands Moving',
  'American Home Movers','Elite Pack & Move','NextGen Relocations','BlueLine Movers',
  'Keystone Moving Co','Prime Relocation','Ace Moving Services','Capital City Movers',
  'Lighthouse Movers','Harbor Moving Co','Heartland Relocations','Frontier Moving Group',
];

// ─── Pool 5: Move types ─────────────────────────────────────────────
const moveTypes = [
  'local move','long-distance move','office move','apartment move','studio move',
  '3-bedroom move','storage move','piano move','packing service','house move',
  'condo move','townhouse move','senior move','military move',
];

// ─── Pool 6: Time stamps ────────────────────────────────────────────
const times = [
  'just now','1 min ago','2 min ago','3 min ago','4 min ago','5 min ago',
  '6 min ago','7 min ago','8 min ago','9 min ago','10 min ago','12 min ago',
];

// ─── Pool 7: Price ranges by category ───────────────────────────────
const priceRange = (type) => {
  if (type.includes('long-distance')) return randInt(12, 45) * 100;
  if (type.includes('office')) return randInt(8, 20) * 100;
  if (type.includes('piano')) return randInt(3, 8) * 100;
  if (type.includes('packing')) return randInt(2, 6) * 100;
  return randInt(3, 12) * 100;
};

// ─── Notification generator ─────────────────────────────────────────
const TYPES = [
  ['quote',     0.28],
  ['review',    0.20],
  ['match',     0.15],
  ['completed', 0.13],
  ['joined',    0.08],
  ['accepted',  0.09],
  ['live',      0.07],
];

export function generateNotification() {
  const category = weighted(TYPES);
  const time = pick(times);

  switch (category) {
    case 'quote': {
      const name = pick(names);
      const { from, to } = pickRoute();
      return {
        category,
        headline: `${name} requested a quote`,
        detail: `${from} → ${to}`,
        time,
        accent: 'text-amber-400',
        bg: 'bg-amber-400/10',
      };
    }
    case 'review': {
      const name = pick(names);
      const city = pick(allCities);
      const stars = weighted([['★★★★★', 0.6], ['★★★★☆', 0.3], ['★★★☆☆', 0.1]]);
      return {
        category,
        headline: `${stars}  "${pick(reviews)}"`,
        detail: `— ${name}, ${city}`,
        time,
        accent: 'text-yellow-400',
        bg: 'bg-yellow-400/10',
      };
    }
    case 'match': {
      const n = randInt(2, 6);
      const { from, to } = pickRoute();
      return {
        category,
        headline: `${n} movers matched`,
        detail: `${from} → ${to}`,
        time,
        accent: 'text-emerald-400',
        bg: 'bg-emerald-400/10',
      };
    }
    case 'completed': {
      const name = pick(names);
      const { from, to } = pickRoute();
      return {
        category,
        headline: `${name}'s move completed`,
        detail: `${from} → ${to}`,
        time,
        accent: 'text-blue-400',
        bg: 'bg-blue-400/10',
      };
    }
    case 'joined': {
      const company = pick(companies);
      const city = pick(allCities);
      return {
        category,
        headline: `${company} just joined`,
        detail: `Serving ${city} area`,
        time,
        accent: 'text-purple-400',
        bg: 'bg-purple-400/10',
      };
    }
    case 'accepted': {
      const name = pick(names);
      const type = pick(moveTypes);
      const price = priceRange(type).toLocaleString();
      return {
        category,
        headline: `${name} accepted a quote`,
        detail: `${type} · $${price}`,
        time,
        accent: 'text-green-400',
        bg: 'bg-green-400/10',
      };
    }
    case 'live': {
      const n = randInt(2, 8);
      const city = pick(allCities);
      return {
        category,
        headline: `${n} movers checking availability`,
        detail: `${city} metro`,
        time,
        accent: 'text-green-300',
        bg: 'bg-green-400/10',
      };
    }
    default:
      return { category: 'quote', headline: 'New activity', detail: '', time, accent: 'text-amber-400', bg: 'bg-amber-400/10' };
  }
}
